import bannerVideo from '../../components/banner-video.vue';
import bannerVideoContent from '../../components/banner-video-content.vue';
import { normal } from '../defaultSpacing';
import spaceMixin from '@/modules/space-mixin';
import styleMixin from '@/modules/color-mixin';
export default {
    mixins: [spaceMixin(), styleMixin()],
    data: function() {
        return {
            title: '',
            desc: '',
            bgColor: '',
            maskOption: {
                showMask: true,
                maskColor: 'rgba(0,0,0,0.2)'
            },
            videoOption: {
                autoplay: false,
                src: '',
                previewSrc: '',
                playInline: true,
                showProgress: true,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false
            },
            leftVideoOption: {
                autoplay: false,
                src: '',
                previewSrc: '',
                playInline: true,
                showProgress: true,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false
            },
            rightVideoOption: {
                autoplay: false,
                src: '',
                previewSrc: '',
                playInline: true,
                showProgress: true,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: false
            },
            videoList: [],
            columns: 3,
            spacing: 20,
            ...normal
        };
    },
    components: {
        bannerVideo,
        bannerVideoContent
    }
};
